import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import '../../Assets/css/userDoc.scss';
function Test(props) {

    return (
        <div className="gridcontainer userGridContainer">
            <div className={`totalworkercontent`}>
                <div className="gridtopviews gridtopviewsHistory gridtopviewsAllSectionBox">

                </div>
                <div className='grid_content_inner'>
                    <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative' }}>
                        Test
                    </div>
                </div>
            </div>


        </div>
    );
};

Test.defaultProps = {
    adminFilterShow: true
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        userGroup: globalState.LoginReducer.userGroup,
        userEntryType: globalState.LoginReducer.userEntryType,
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(Test));
